import { Box } from "@mui/material";
import { WorkflowComponent } from "./WorkflowComponent";
import { useParams } from "react-router";
import { selectWorkflow } from "store/dataReducers/workflowSlice";
import { useDispatch } from "react-redux";

export const WorkflowPage = () => {

  const { id } = useParams()
  const dispatch = useDispatch()
  
  dispatch(selectWorkflow(id!))

  return (
    <Box sx={{ p: 2 }}>
      <WorkflowComponent 
        workflowDocId={id!}/>
    </Box>
  )
};